// extracted by mini-css-extract-plugin
export default {"badge":"WalletBadge_badge__iXQr7","badgeName":"WalletBadge_badgeName__6ivTS","web3":"WalletBadge_web3__jArGC"};